define('tdmain', ['jquery'], function ($) {

  var tdmain = {
    js_backArrow: function js_backArrow() {
      var backArrow = $('.js_backArrow');
      var backArrowShowClass = 'js_ArrowShow';
      var _window = $(window);
      var speedTime = 500;
      var timer = void 0;
      var isShow = false;

      _window.scroll(function () {
        if (_window.scrollTop() > speedTime) {
          if (!isShow) {
            isShow = true;
            backArrow.addClass(backArrowShowClass);
          }
          if (timer) {
            clearTimeout(timer);
          }
          timer = setTimeout(function () {
            backArrow.removeClass(backArrowShowClass);
            isShow = false;
          }, 3500);
        }
      });

      backArrow.on('mouseenter', function () {
        if (timer) clearTimeout(timer);
      }).on('click', function (e) {
        $('body,html').animate({ scrollTop: 0 }, speedTime, function () {
          backArrow.removeClass(backArrowShowClass);
        });
      });
    },
    categorieSlider: function categorieSlider() {
      var container = $('.category__categories');
      if (container && window.wabreakpoint !== 'small') {
        var containerWidth = container.width();
        var childs = container.children();
        var totalWidth = 0;

        childs.each(function (i, el) {
          totalWidth += $(el).outerWidth() + 7;
          if (totalWidth >= containerWidth) {
            $(el).remove();
          }
        });
      }
      if (container) {
        container.addClass('show');
      }
    },
    footerLinksOpenClose: function footerLinksOpenClose() {
      var footerLinksHeadlines = $('[data-small-next-close]');
      var openClassname = 'js_open';
      footerLinksHeadlines.on('click', function (e) {
        var self = $(e.currentTarget);

        if (self.hasClass(openClassname)) {
          $(e.currentTarget).removeClass(openClassname);
        } else {
          footerLinksHeadlines.removeClass(openClassname);
          $(e.currentTarget).addClass(openClassname);
        }
      });
    },
    mobileImageFader: function mobileImageFader() {
      var $imageFader = $('.image-fader');
      if ($imageFader.length) {
        $imageFader.on('touchstart', function (e) {
          $(e.currentTarget).toggleClass('active');
        });
      }
    },
    removeSpaces: function removeSpaces() {
      $('[type="email"]').on('blur', function (e) {
        var self = $(this);
        self.val(self.val().replace(/\s/g, ''));
      });
    },
    init: function init() {
      this.js_backArrow();
      this.categorieSlider();
      this.footerLinksOpenClose();
      this.mobileImageFader();
      this.removeSpaces();
    }
  };

  return tdmain;
});

